import React from 'react'

const InfoIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="infoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(100, 180, 255, 1)" />
          <stop offset="100%" stopColor="rgba(60, 140, 220, 1)" />
        </linearGradient>
        <filter id="infoGlow">
          <feGaussianBlur stdDeviation="1.5" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Circle */}
      <circle 
        cx="12" 
        cy="12" 
        r="9"
        stroke="url(#infoGradient)"
        strokeWidth="2"
        fill="none"
        filter="url(#infoGlow)"
      />
      
      {/* "i" dot */}
      <circle 
        cx="12" 
        cy="8" 
        r="1.5" 
        fill="url(#infoGradient)"
      />
      
      {/* "i" line */}
      <line 
        x1="12" 
        y1="11" 
        x2="12" 
        y2="17" 
        stroke="url(#infoGradient)"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default InfoIcon
